var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"horizontal-scroll-container"},[_c('div',{staticClass:"wrapper",style:({ minWidth: _vm.minWidth + 'px' })},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }